import axios from "../utils/axios";

export const getRootCauseFamilies = () => {
    return axios.get(`/EwoForm/RootCausesFamilyOptions`);
};

export const getRootCauseFamilyOptions = (payload) => {
    return axios.get(`/EwoForm/RootCausesFamilyOptions/${payload}`);
};

export const getOperatorFiveWsOneHAnalysis = () => {
    return axios.get(`/EwoForm/OperatorFiveWsOneHAnalysis`);
};

export const postEwoFormCreateWithFile = (data) => {
    console.log('data: ', data);
    return axios.post(`/EwoForm/AddTechnicianFieldsForEwoForm?taskId=${data.taskId}`, data);
};

export const postEwoFormCreateWithOperatorFields = (data) => {
    return axios.post(`/EwoForm/AddEwoFormAndOperatorFileds`, data);
};

export const getEwoForms = (payload) => {
    return axios.post(`/EwoForm/GetPagedMultipleChoices?PageSize=${payload.payload.pageSize}&PageNumber=${payload.payload.currentPage}`, payload.payload.data);
};

export const getEwoFormDetailById = (payload) => {
    return axios.get(`/EwoForm/GetEwoFormById/` + payload);
}

export const getFormDetail = (payload) => {
    return axios.get(`/EwoForm/GetEwoFormById/` + payload);
}

export const getCheckHasEwoForm = (payload) => {
    return axios.get(`/UnplannedMaintenance/EwoFormControlByTaskId?TaskId=${payload}`);
}

export const getOperatorFieldsByTaskId = (payload) => {
    return axios.get(`/EwoForm/GetEwoFormByTaskId/` + payload);
}

export const postAddEwoFormFileWithEmergencyWorkOrdId = (payload) => {
    return axios.post(`EwoForm/${payload.id}/files`, payload.file)
}

export const postAddEwoFormToDrafts = (data) => {
    return axios.post(`EwoForm/AddToDrafts`, data)
}

export const getToDraftsByTaskId = (payload) => {
    return axios.get(`EwoForm/GetToDraftsByTaskId/` + payload);
}

export const deleteToDraftsByTaskId = (payload) => {
    return axios.delete(`EwoForm/DeleteToDraftsByTaskId/` + payload);
}

export const getEwoFormFileByTaskId = (payload) => {
    return axios.get(`/EwoForm/${payload}/files`, {
        responseType: 'blob'
    })
}

export const deleteEwoFromFileByEwoId = (payload) => {
    return axios.delete(`/EwoForm/DeleteEwoFormFileWithId?ewoId=${payload}`);
}

export const getFormDetailById = (payload) => {
    return axios.get(`/EwoForm/GetEwoFormById/` + payload);
}